import React, { useContext } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, Grid, TextField } from "@material-ui/core";
import { useFormik } from "formik";
import DialogTitleComponent from "../../../../components/dialog_title";
import { TemplateRequest } from "../../../../services/request/reclutamiento/cartas_oferta";
import { FormikInitialValues, FormikValidationSchema } from "./utils";
import { MainContext } from "../../../../App";

export default function DialogAdd(props) {
	const {
		is_open,
		handle_close,
		mutate_cartas_oferta,
	} = props;

	const MainCTX = useContext(MainContext);

	const formik = useFormik({
		initialValues: FormikInitialValues,
		validationSchema: FormikValidationSchema,
		onSubmit: async (values, helper) => {
			try {
				await TemplateRequest.Agregar(values);
				MainCTX.ShowSnackbar("Carta de oferta agregada exitosamente.");
			} catch (error) {
				MainCTX.ShowSnackbar("Error al intentar agregar la carta de oferta.", error);
			} finally {
				helper.resetForm();
				mutate_cartas_oferta();
				handle_close();
			}
		}
	});

	return (
		<Dialog open={is_open} onClose={handle_close} maxWidth="md" PaperProps={{ style: { borderRadius: 20 } }} fullWidth>
			<DialogTitleComponent onClose={handle_close}>Agregar carta de oferta</DialogTitleComponent>
			<DialogContent>
				<DialogContentText>
					{"Ingrese la información requerida de la carta de oferta y luego guarde los cambios."}
				</DialogContentText>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<TextField
							name="nombre"
							label="Nombre"
							onChange={formik.handleChange}
							variant="outlined"
							required
							fullWidth
							size="small"
							helperText={formik.errors.nombre}
							error={Boolean(formik.errors.nombre)}
						/>
					</Grid>
					<Grid item xs={12}>
						<TextField
							name="link_template"
							label="Link template"
							onChange={formik.handleChange}
							variant="outlined"
							required
							fullWidth
							size="small"
							helperText={formik.errors.link_template}
							error={Boolean(formik.errors.link_template)}
						/>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={handle_close} color="primary">Cancelar</Button>
				<Button onClick={formik.submitForm} disabled={formik.isSubmitting} variant="contained" color="primary">Aceptar</Button>
			</DialogActions>
		</Dialog>
	);
}